export default __webpack_public_path__ + "static/media/mp4.20aa752d.png";